// extracted by mini-css-extract-plugin
export default {"p_content":"_018c0bcafd"};